import Transformer from './Transformer';

class itemTransformOffersV4NoAds extends Transformer {
    transform(model) {
        return this.normalizeItem(model);
    }

    /**
     * Desenvuelve la respuesta de la API v4 y normaliza los textos de traducción al formato de arreglo.
     * Se usa cuando ADS está deshabilitado: la rama sin ADS de CardNew lee los textos de traducción
     * como arreglos: texts[0].text, texts[1].text, etc.
     * @param {object} response - Respuesta sin procesar de la API v4 { data: [...] }
     * @returns {Array}
     */
    getItems(response) {
        const data = (response && response.data) ? response.data : [];
        const normalize = data.map(item => this.normalizeItem(item));
        return {offers:normalize};
    }

    /**
     * Elimina los campos exclusivos de v4 y normaliza los campos de texto de traducción a arreglos.
     * Conserva: producttype, price, assets, translation, _links
     * Elimina: product_id, purchasable
     * @param {object} item
     * @returns {object}
     */
    normalizeItem(item) {
        if (!item || typeof item !== 'object') {
            return {};
        }
        const { producttype, price, assets, translation, _links } = item;
        return {
            producttype,
            price,
            assets,
            translation: this.normalizeTranslation(translation),
            _links,
        };
    }

    /**
     * Normaliza todos los campos de texto de traducción de objeto a formato de arreglo.
     * @param {object} translation
     * @returns {object}
     */
    normalizeTranslation(translation) {
        if (!translation) return translation;
        return {
            ...translation,
            txtPromo: translation.txtPromo
                ? { ...translation.txtPromo, texts: this.normalizeTexts(translation.txtPromo.texts) }
                : translation.txtPromo,
            btnFeatures: translation.btnFeatures
                ? { ...translation.btnFeatures, texts: this.normalizeTexts(translation.btnFeatures.texts) }
                : translation.btnFeatures,
            btnSuscription: translation.btnSuscription
                ? { ...translation.btnSuscription, texts: this.normalizeTexts(translation.btnSuscription.texts) }
                : translation.btnSuscription,
        };
    }

    /**
     * Normaliza un objeto de textos a un arreglo, filtrando las entradas de texto falsas.
     *
     * Dos formas de entrada:
     *   - { text1, text2, text3 }            → [{ text }]
     *   - { text1, color1, text2, color2 }   → [{ text, color }]
     *
     * @param {object|Array} texts
     * @returns {Array}
     */
    normalizeTexts(texts) {
        if (!texts || typeof texts !== 'object' || Array.isArray(texts)) {
            return texts;
        }

        const hasColors = 'color1' in texts || 'color2' in texts;

        if (hasColors) {
            return [
                texts.text1 ? { text: texts.text1, color: texts.color1 } : null,
                texts.text2 ? { text: texts.text2, color: texts.color2 } : null,
            ].filter(Boolean);
        }

        return [texts.text1, texts.text2, texts.text3]
            .filter(Boolean)
            .map(function(t) { return { text: t }; });
    }
}

export default new itemTransformOffersV4NoAds();



// WEBPACK FOOTER //
// ./src/requests/transformers/itemTransformOffersV4NoAds.js